import './Loading.scss';

export function Loading() {
  return (
    <div className="spinner-box">
      <div className="spinner"></div>
    </div>
  );
}
